import React, { useRef, useState, useEffect } from 'react';
import useNotifications from '../../../api/notifications';
import NotificationsList from './NotificationsList';
import { FaBell } from 'react-icons/fa';

export default function NotificationBell() {
    const { list } = useNotifications({ page: 1, limit: 10, unreadOnly: true });
    const unreadCount = list.data?.unread || 0;

    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    // close on outside click
    useEffect(() => {
        const onDocClick = (e) => {
            if (!wrapRef.current) return;
            if (!wrapRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    return (
        <div ref={wrapRef} className="position-relative">
            <button
                type="button"
                className="btn btn-light position-relative"
                onClick={() => setOpen((o) => !o)}
                aria-label="Notifications"
            >
                <FaBell />
                {unreadCount > 0 && (
                    <span className="position-absolute top-50 start-100 translate-middle badge rounded-pill bg-danger">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
                )}
            </button>

            {open && (
                <div
                    className="card shadow-sm"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '110%',
                        width: 360,
                        maxHeight: 420,
                        overflow: 'auto',
                        zIndex: 1050,
                    }}
                >
                    <NotificationsList />
                </div>
            )}
        </div>
    );
}
